import './ltmanagement/style';
import FormStructure from './ltmanagement/form_structure';

export default FormStructure;